import { withInstall } from '@hd-front-end/utils'
import Slider from './src/slider.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElSlider: SFCWithInstall<typeof Slider> = withInstall(Slider)
export default ElSlider

export * from './src/slider'
export * from './src/constants'
